/* eslint-disable max-lines */
import {
  FormStepFailure,
  FormStepSuccess,
  CreateAccountFailureComponent,
  CreateAccountSuccessComponent,
  MultiStepForm,
  FormStep,
  InputField,
  SelectField,
  PasswordField,
  CheckboxField,
  TelephoneField,
  DateField,
  UsernameField,
  SSNField,
  FieldReference,
  AddressField,
  EmploymentStatus,
  OccupationsField,
  MarketingPreferencesField,
  LimitField,
  CitizenshipField,
  LossLimitPeriodSelectConfiguration,
  emailRegex,
} from '@whitehatgaming/shared';
import { CreateAccountComponent } from './create-account/create-account.component';

export const registerOntario: MultiStepForm = new MultiStepForm({
  rootComponent: CreateAccountComponent,

  success: new FormStepSuccess({
    path: 'success',
    component: CreateAccountSuccessComponent,
  }),

  failure: new FormStepFailure({
    path: 'failed',
    component: CreateAccountFailureComponent,
  }),

  steps: [
    new FormStep({
      key: 'personal-details',
      title: '@personal-details-title-ontario',
      supportingText: '@personal-details-supporting-text-ontario',
      buttonText: '@personal-details-button-text-ontario',
      trackingSnippets: [
        {
          tagName: 'script',
          onlyLive: true,
          properties: {
            type: 'text/javascript',
            innerHTML: `
                  var w = window, d = document;
                  var s = d.createElement('script');
                  s.setAttribute('async', 'true');
                  s.setAttribute('type', 'text/javascript');
                  s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
                  var f = d.getElementsByTagName('script')[0];
                  f.parentNode.insertBefore(s, f);
                  if (typeof w['_rfi'] !== 'function') {
                    w['_rfi']=function() {
                      w['_rfi'].commands = w['_rfi'].commands || [];
                      w['_rfi'].commands.push(arguments);
                    };
                  }
                  _rfi('setArgs', 'ver', '9');
                  _rfi('setArgs', 'rb', '40291');
                  _rfi('setArgs', 'ca', '20820959');
                  _rfi('setArgs', '_o', '40291');
                  _rfi('setArgs', '_t', '20820959');
                  _rfi('track');`,
          },
        },
      ],
      fields: [
        new InputField({
          key: 'firstname',
          placeholder: '@first-name-ontario',
          label: '@first-name-ontario',
          value: '',
          required: true,
          pattern: new RegExp(/^[a-z\s]+$/, 'i'),
        }),

        new InputField({
          key: 'middleName',
          placeholder: '@middle-name-ontario',
          value: '',
          pattern: new RegExp(/^[a-z\s]+$/, 'i'),
        }),

        new InputField({
          key: 'lastname',
          placeholder: '@last-name-ontario',
          label: '@last-name-ontario',
          value: '',
          pattern: new RegExp(/^[a-z\s]+$/, 'i'),
          required: true,
        }),

        new InputField({
          key: 'preferredName',
          placeholder: '@preferred-name-ontario',
          value: '',
          pattern: new RegExp(/^[a-z\s]+$/, 'i'),
        }),

        new SelectField({
          key: 'gender',
          placeholder: '@select-gender',
          value: '',
          required: true,
          label: '@gender-ontario',
          options: [
            { key: 'M', value: '@gender-male-ontario' },
            { key: 'F', value: '@gender-female-ontario' },
            { key: 'O', value: '@gender-other-ontario' },
          ],
        }),

        new DateField({
          key: 'dob',
          label: '@birth-date-ontario',
          preText: '@date-format',
          value: '',
          legalAge: 19,
          required: true,
        }),

        new SelectField({
          key: 'country',
          placeholder: '@country-ontario',
          label: '@country-ontario',
          value: 'CA',
          options: [{ key: 'CA', value: 'CANADA' }],
          required: true,
        }),

        new SelectField({
          key: 'state',
          placeholder: '@state-ontario',
          label: '@state-ontario',
          required: true,
          value: 'Ontario',
          options: [{ key: 'Ontario', value: 'Ontario' }],
        }),

        new SSNField({
          key: 'ssn',
          label: '@personal-identity-number',
          preText: '@personal-identity-number-help-text',
          value: '',
        }),

        new InputField({
          key: 'mkgv',
          label: '',
          value: '',
          required: false,
          hidden: true,
        }),
      ],
    }),

    new FormStep({
      key: 'address-details',
      buttonText: '@address-details-continue-ontario',
      title: '@address-details-title-ontario',
      supportingText: '@address-details-supporting-text-ontario',
      trackingSnippets: [
        {
          tagName: 'script',
          onlyLive: true,
          properties: {
            type: 'text/javascript',
            innerHTML: `
                  var w = window, d = document;
                  var s = d.createElement('script');
                  s.setAttribute('async', 'true');
                  s.setAttribute('type', 'text/javascript');
                  s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
                  var f = d.getElementsByTagName('script')[0];
                  f.parentNode.insertBefore(s, f);
                  if (typeof w['_rfi'] !== 'function') {
                    w['_rfi']=function() {
                      w['_rfi'].commands = w['_rfi'].commands || [];
                      w['_rfi'].commands.push(arguments);
                    };
                  }
                  _rfi('setArgs', 'ver', '9');
                  _rfi('setArgs', 'rb', '40291');
                  _rfi('setArgs', 'ca', '20820960');
                  _rfi('setArgs', '_o', '40291');
                  _rfi('setArgs', '_t', '20820960');
                  _rfi('track');`,
          },
        },
      ],
      fields: [
        new InputField({
          key: 'email',
          label: '@email-ontario',
          placeholder: '@email-ontario',
          value: '',
          required: true,
          type: 'email',
          pattern: emailRegex,
        }),

        new TelephoneField({
          key: 'phone',
          label: '@phone-ontario',
          placeholder: '@phone-ontario',
          prefix: 1,
          value: '',
          required: true,
        }),

        new AddressField({
          key: 'address',
          label: '@address-ontario',
          value: '',
          pattern: new RegExp(/(^(?!.*?P.O.|office|postal).*)/),
          postalcodePattern: new RegExp(/(^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVXYWZ][ 0-9ABCEGHJKLMNPRSTVXYWZ]*$)/, 'i'),
          manualAddressPattern: new RegExp(/^[a-z0-9\s]+$/, 'i'),
          manualTownPattern: new RegExp(/^[a-z\s]+$/, 'i'),
          hoverText: '@postalCode-format-rules-ont',
          required: true,
        }),

        new CitizenshipField({
          key: 'citizenship',
          label: '@citizenship-ontario',
          value: '',
          skippedDefaultCountries: ['NL', 'SE'],
        }),

        new SelectField({
          key: 'occupationsState',
          label: '@occupations-state-ontario',
          value: '',
          required: true,
          placeholder: '@please-select-ontario',
          options: [
            { key: EmploymentStatus.EMPLOYED, value: '@sow-status-label-1-ontario' },
            { key: EmploymentStatus.UNEMPLOYED, value: '@sow-status-label-3-ontario' },
            { key: EmploymentStatus.SELF_EMPLOYED, value: '@sow-status-label-2-ontario' },
            { key: EmploymentStatus.RETIRED, value: '@sow-status-label-4-ontario' },
          ],
        }),
        new OccupationsField({
          key: 'occupationId',
          label: '@occupations-ontario',
          value: '',
          required: true,
          placeholder: 'select',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
        new InputField({
          key: 'employerName',
          label: '@company-ontario',
          value: '',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
        new InputField({
          key: 'employerAddress',
          label: '@company-address-ontario',
          pattern: new RegExp(/(^(?!.*?P.O.|office|postal).*)/),
          value: '',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
        new InputField({
          key: 'employerCity',
          label: '@company-city-ontario',
          pattern: new RegExp(/(^(?!.*?P.O.|office|postal).*)/),
          value: '',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
        new InputField({
          key: 'employerZip',
          label: '@company-zip-ontario',
          pattern: new RegExp(/(^(?!.*?P.O.|office|postal).*)/),
          value: '',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
        new InputField({
          key: 'employerProvince',
          label: '@company-province-ontario',
          pattern: new RegExp(/(^(?!.*?P.O.|office|postal).*)/),
          value: '',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
        new TelephoneField({
          key: 'businessPhone',
          label: '@company-phone-ontario',
          prefix: 1,
          value: '',
          conditional:
            'this.occupationsState === "employed" || this.occupationsState === "self_employed"',
        }),
      ],
    }),

    new FormStep({
      key: 'account-details',
      buttonText: '@sign-up-ontario',
      title: '@account-details-title-ontario',
      supportingText: '@account-details-supporting-text',
      trackingSnippets: [
        {
          tagName: 'script',
          onlyLive: true,
          properties: {
            text: 'text/javascript',
            innerHTML: `
                  var w = window, d = document;
                  var s = d.createElement('script');
                  s.setAttribute('async', 'true');
                  s.setAttribute('type', 'text/javascript');
                  s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
                  var f = d.getElementsByTagName('script')[0];
                  f.parentNode.insertBefore(s, f);
                  if (typeof w['_rfi'] !== 'function') {
                    w['_rfi']=function() {
                      w['_rfi'].commands = w['_rfi'].commands || [];
                      w['_rfi'].commands.push(arguments);
                    };
                  }
                  _rfi('setArgs', 'ver', '9');
                  _rfi('setArgs', 'rb', '40291');
                  _rfi('setArgs', 'ca', '20820961');
                  _rfi('setArgs', '_o', '40291');
                  _rfi('setArgs', '_t', '20820961');
                  _rfi('track');`,
          },
        },
      ],
      fields: [
        new UsernameField({
          key: 'username',
          label: '@username-ontario',
          placeholder: '@username-ontario',
          value: '',
          preText: '@username-help-text-ontario',
          pattern: new RegExp(/^[a-z0-9\s]+$/, 'i'),
          minLength: 8,
          maxLength: 20,
          required: true,
        }),

        new PasswordField({
          key: 'password',
          label: '@password-ontario',
          placeholder: '@password-ontario',
          preText: '@password-help-text-ontario',
          value: '',
          minLength: 8,
          required: true,
          email: new FieldReference('email'),
        }),

        new SelectField({
          key: 'currency',
          label: '@currency',
          value: 'CAD',
          required: true,
          options: [{ key: 'CAD', value: 'CAD' }],
        }),

        new SelectField({
          key: 'display',
          label: '@display-ontario',
          parentClass: 'displayer',
          placeholder: '@please-select-ontario',
          options: [
            { key: 'show', value: '@show-ontario' },
            { key: 'hide', value: '@hide-ontario' },
          ],
        }),

        new LimitField({
          key: 'depositlimit',
          label: '@deposit-limit-ontario',
          conditional: 'this.display === "show"',
          hoverText: '@hoverText-deposit-ontario',
          placeholder: '@period-please-select-ontario',
          pattern: new RegExp(/[0-9]+/),
          period: '',
          value: '',
          periods: LossLimitPeriodSelectConfiguration,
        }),

        new LimitField({
          key: 'rglosslimit',
          label: '@loss-limits-ontario',
          conditional: 'this.display === "show"',
          hoverText: '@hoverText-losslimit-ontario',
          placeholder: '@period-please-select-ontario',
          period: '',
          value: '',
          periods: LossLimitPeriodSelectConfiguration,
        }),

        new CheckboxField({
          key: 'termsPrivacyFunds',
          parentClass: 'bottom-margin-small checkbox-limit-container',
          label: '@terms-and-conditions-privacy-policy-and-funds-policy-19',
          required: true,
        }),
        new CheckboxField({
          key: 'testTermsPrivacyFundsPep',
          label: '@terms-and-conditions-pep',
          parentClass: 'no-bottom-margin',
          required: true,
        }),
        new CheckboxField({
          key: 'testTermsPrivacyFunds',
          label: '@terms-and-conditions-fit-to-play',
          hoverText: '@terms-and-conditions-fit-to-play-hover',
          parentClass: 'no-bottom-margin',
          required: true,
        }),
        new MarketingPreferencesField(
          {
            label: '@marketing-preferences-title',
            preText: '@marketing-preferences-pre-text',
            postText: '@marketing-preferences-post-text',
          },
          {
            crossNetwork: '@marketing-preferences-cross-marketing-description',
            channels: {
              email: '@marketing-preferences-contact-options-email',
              phone: '@marketing-preferences-contact-options-phone',
              sms: '@marketing-preferences-contact-options-sms',
              crossEmail: '@marketing-preferences-contact-options-email',
              crossPhone: '@marketing-preferences-contact-options-phone',
              crossSms: '@marketing-preferences-contact-options-sms',
            },
          }
        ),
      ],
    }),
  ],
});
